export const HomeIcon = ({ active }: { active: boolean }) => {
  const fillColor = active ? "#031423" : "currentColor";

  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    fill="none"
  >
    <mask id="a" width="30" height="30" x="0" y="0" maskUnits="userSpaceOnUse">
      <path fill="#D9D9D9" d="M0 0h30v30H0z" />
    </mask>

    <g mask="url(#a)">
      <path
        fill={fillColor}
        d="M7.083 24.167h4.375V17.5c0-.295.1-.543.3-.742.2-.2.447-.3.742-.3h5c.295 0 .542.1.742.3.2.2.3.447.3.742v6.667h4.374V12.292L15 6.354l-7.917 5.938v11.875Zm-2.083 0V12.292a2.07 2.07 0 0 1 .833-1.667l7.917-5.938a1.998 1.998 0 0 1 1.246-.416c.468 0 .886.139 1.254.417l7.916 5.937A2.07 2.07 0 0 1 25 12.292v11.875c0 .572-.204 1.063-.612 1.471a2.007 2.007 0 0 1-1.472.612H17.5c-.296 0-.543-.1-.742-.3-.2-.2-.3-.447-.3-.742v-6.666h-2.917v6.666c0 .295-.1.543-.3.743-.199.2-.446.299-.741.299H7.083a2.007 2.007 0 0 1-1.471-.612A2.007 2.007 0 0 1 5 24.167Z"
      />
    </g>
  </svg>
};
